export const JuryMemberCard = ({ image, name, setJuryDetails, id }) => {
    // return (
    //     <div className="avatar jm" onClick={() => setJuryDetails(id)}>
    //         <img src={image} width="34" height="34" alt="img" title={name} />
    //     </div>
    // )

    return (
        <div >
            <div className="media">
                <div className="starshot-ring mr-1" onClick={() => setJuryDetails(id)}>
                    <div className="avatar">
                        <div className="text-icon font-lato">{name[0]}</div>
                    </div>
                </div>
                <div className="media-body my-auto">
                    <p className="mb-0 font-lato">{name}</p>
                    <p className="mb-0 font-lato font-10 star-orange cursor-pointer" onClick={() => setJuryDetails(id)}>View</p>
                </div>
            </div>
            <hr className="border-blue-starshot" />
        </div>
    )
}